import React, { useState, useEffect } from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import helpers from "../../../helpers";
import { ReactComponent as IconInfoCircle } from 'bootstrap-icons/icons/info-circle.svg'

import Dropdown from "./Dropdown";


function Emails(props) {
  const { t } = useTranslation();
  const [modal, setModal] = useState();
  const [state, setState] = useState([]);

  const slice = (index1) => {
    const newState = state.filter((item, index2) => index1 !== index2);
    setState(JSON.clone([...newState]));
    props.onChange(JSON.clone([...newState]));
  };

  const add = () => {
    // Bug real (auditoría 2026-08-14): no llamaba a props.onChange, a
    // diferencia de slice/onChange (que sí lo hacen tras el setState). Una
    // fila nueva vacía quedaba invisible para el padre — si el padre trackea
    // "cambios sin guardar" diffeando los payloads de onChange (patrón usado
    // en Setup/Users/Users.js), navegar fuera justo después de tocar "+"
    // perdía la fila en silencio, sin warning de cambios sin guardar.
    const array = JSON.clone([...state, { ...props.options }]);
    setState(array);
    props.onChange(array);
  };

  const onChange = (index) => ({ target: { name, value, type } }) => {
    // Bug real (auditoría 2026-08-14): mutaba `state[index]` ANTES de
    // clonar. El useEffect de sincronización de más abajo solo hace un clon
    // shallow del array (`[...props.value]`), así que `state[index]` sigue
    // siendo la MISMA referencia que `props.value[index]` — el objeto vivo
    // del padre. Mutarlo acá pisaba ese dato en el momento, antes de que
    // props.onChange llegara a dispararse. Clonar primero, mutar la copia.
    const array = JSON.clone([...state]);
    if (value && type === "number") {
      array[index][name] = +value;
    } else if (type === "checkbox") {
      array[index][name] = !array[index][name];
    } else {
      array[index][name] = value;
    }
    setState(array);
    props.onChange(array);
    setModal();
  };

  useEffect(() => {
    setState([...props.value]);
  }, [props.value]);

  return (
    <div className="mb-3">
      {/* sectionLabel: variante del handoff de Figma — rotulo en micro-etiqueta
          y "+" fino al extremo derecho. Solo la piden las pantallas ya
          migradas; sin la prop se mantiene el estilo de siempre, que es el que
          usa el resto de la app. */}
      <div
        className={cx(
          props.sectionLabel
            ? "form-section-label form-section-label--with-action"
            : "d-flex align-items-center form-label"
        )}
      >
        {/* label: igual que sectionLabel, opt-in. El handoff rotula esta
            seccion "Correo electronico" y no "Emails", que es lo que devuelve
            la API para email_plural y se sigue usando en el resto de la app. */}
        <label htmlFor="emails">
          {props.label || t("email_plural", { context: props.context })}
        </label>
        {!props.disabled && (
          <button
            onClick={add}
            type="button"
            className={cx("btn btn-link p-0", {
              "ms-2": !props.sectionLabel,
              "form-section-label__action": props.sectionLabel,
            })}
            aria-label={t("email_add", { context: props.context, defaultValue: "Agregar correo electrónico" })}
          >
            {props.sectionLabel ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                aria-hidden="true"
              >
                <path d="M8 3.25v9.5M3.25 8h9.5" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus-square-fill"
                viewBox="0 0 16 16"
                aria-hidden="true"
              >
                <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
              </svg>
            )}
          </button>
        )}
      </div>
      {state.map((email, index) => (
        <div
          className={cx("position-relative", {
            "mb-1": index !== state.length - 1,
          })}
          key={`email${index}`}
        >
          <input
            type="email"
            name="value"
            autoComplete="--disable"
            required={props.required}
            disabled={!!props.disabled}
            id={`email${index}`}
            placeholder={t("email_placeholder")}
            value={email.value || ""}
            onChange={onChange(index)}
            className="form-control"
          />
          <div className="form-control-actions d-flex align-items-center gap-1">
            {email.source && email.source !== "drapp" &&
              <div>
                <IconInfoCircle
                  width="14"
                  height="14"
                  data-tooltip-id="app-tooltip"
                  data-tooltip-html={`
                    <div>
                      ${t("entered_by_patient" ,{context: props.context, defaultValue: "Ingresado por paciente"})}
                    </div>`
                  }
                />
              </div>
            }
            {!props.disabled &&
              helpers.isEmail(email.value) &&
              Object.keys(props.options || {}).length > 0 && (
                <Dropdown
                  value={email}
                  options={props.options}
                  onChange={onChange(index)}
                  context={props.context}
                  // Bug real (auditoría 2026-08-14): Dropdown usaba ids
                  // hardcodeados (emailAgenda/emailSummary/emailEveryEvent)
                  // — con 2+ filas de email, cada fila repetía los mismos
                  // ids en el DOM, así que el label de cualquier fila
                  // enfocaba siempre el select de la PRIMERA. idPrefix hace
                  // únicos los ids por fila.
                  idPrefix={`email${index}`}
                />
              )}
            {!props.disabled && (
              // Fix responsive (2026-08-14): py-0 px-1 sobre un ícono de
              // 1em — hit-target chico, repetido en cada fila de email de
              // todos los formularios que usan este componente.
              <button
                className="btn btn-sm text-danger py-2 px-2"
                type="button"
                onClick={() => slice(index)}
              >
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  className="bi bi-x"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
                  />
                  <path
                    fillRule="evenodd"
                    d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      ))}
      {state.length > 0 && (
        <div className="d-flex align-items-center justify-content-between">
          <div
            className="form-text"
            dangerouslySetInnerHTML={{
              __html: t(`email_hint`, {
                context: props.context,
                defaultValue: "Para notificaciones de turnos.",
              }),
            }}
          />
        </div>
      )}
    </div>
  );
}
export default Emails;
